/** Raw GLSL sources with `#include` chunks resolved at import time. */

import commonChunk from './common.glsl?raw';
import colormapsChunk from './colormaps.glsl?raw';
import quadVertSrc from './quad.vert.glsl?raw';
import stainFragSrc from './stain.frag.glsl?raw';
import raymarchFragSrc from './raymarch.frag.glsl?raw';
import presentFragSrc from './present.frag.glsl?raw';
import wireVertSrc from './wire.vert.glsl?raw';
import wireFragSrc from './wire.frag.glsl?raw';

import { resolveIncludes } from '../core/gl';

const chunks: Record<string, string> = {
  'common.glsl': commonChunk,
  'colormaps.glsl': colormapsChunk,
};

export const shaders = {
  quadVert: resolveIncludes(quadVertSrc, chunks),
  stainFrag: resolveIncludes(stainFragSrc, chunks),
  raymarchFrag: resolveIncludes(raymarchFragSrc, chunks),
  presentFrag: resolveIncludes(presentFragSrc, chunks),
  wireVert: resolveIncludes(wireVertSrc, chunks),
  wireFrag: resolveIncludes(wireFragSrc, chunks),
};

export const CUSTOM_RULE_MARKER = '//__CUSTOM_RULE__';
